// extracted by mini-css-extract-plugin
module.exports = {"container":"AssignGroupManager_container__3c9dj","header":"AssignGroupManager_header__2chWp","assignButton":"AssignGroupManager_assignButton__XZ6BP"};